module.exports = __webpack_public_path__ + "media/Dashboard_Tutorial_Vol1.5f83d43d.mp4";